// Copyright © 2019-2026 Focal Systems. All rights reserved.

import { createFileRoute } from "@tanstack/react-router";
import { Home } from "lucide-react";
import { useTranslation } from "react-i18next";
import { PageHeader } from "@/components/layout/page-header";
import { HomeGreeting } from "@/features/home/home-greeting";
import { HomeMetrics } from "@/features/home/home-metrics";
import { WhatsHappening } from "@/features/home/whats-happening";

export const Route = createFileRoute("/_authenticated/home/")({
  component: HomePage,
});

function HomePage() {
  const { t } = useTranslation("back-office");

  return (
    <div>
      <PageHeader title={t("home.title")} icon={Home} />
      <div className="space-y-6 p-6">
        <HomeGreeting />
        <HomeMetrics />
        {/* Open to every signed-in user: `/v1/home/*` carries no page permission. */}
        {/* `pt-1` on top of the stack's gap: the metrics close the page's intro, so the panels start a new part. */}
        <div className="pt-1">
          <WhatsHappening />
        </div>
      </div>
    </div>
  );
}
